module.exports = __webpack_public_path__ + "img/thumbnail-best-saller-calyrafit.7ba304b2.webp";